module.exports = __webpack_public_path__ + "media/images/common/detail_3-10bd8575829ffad4f43684c0972b5342.png";